module.exports = __webpack_public_path__ + "static/media/Learning-bro (1).01ab6652.png";